// NotificationBell.js
import React, { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa";
import SalonService from "../../services/SalonService";
import "./NotificationBell.css";

export default function NotificationBell({ customerId }) {
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        if (customerId) {
            SalonService.getUnreadCount(customerId).then((res) => {
                setUnreadCount(res.data);
            });
        }
    }, [customerId]);

    return (
        <>
            <span className="bell-wrapper">
                <FaBell className="bell-icon" />
                {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
            </span>
            Notifications
        </>
    );
}
